import { Component, Input, ViewChild, Renderer2, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';
import * as d3 from "d3";

@Component({
  selector: 'app-dashboard-stack',
  templateUrl: './dashboard-stack.component.html',
  styleUrls: ['./dashboard-stack.component.scss']
})
export class DashboardStackComponent implements AfterViewInit {
  @Input() data: any = {};
  @Input() indicators: any = {};
  @Input() navCtrlr: any;

  @ViewChild('dashboardMap', {static: true}) protected mapDivRef: ElementRef;
  @ViewChild('dashControl', {static: true}) protected elemRef: ElementRef;
  protected mapDiv: HTMLDivElement;

  public map: any;
  public layerGroup: any;
  public layerGroupShapes: any;

  public isOpen: any = false;
  public loading: any = true;
  public contId: any;

  public filter: any = 0;

  public metricKeys: any = [];

  constructor(
    private renderer: Renderer2
  ) { }

  ngAfterViewInit(): void {
    this.mapDiv = this.mapDivRef.nativeElement;

    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/dark_all/style.json";

    this.map = L.map('dashboardMap', { scrollWheelZoom: false }).setView([19.329209, -99.018432], 11);

    // 19.369903, -99.148074
    // L.ZoomControl({ postion: 'bottomright' }).addTo(this.map);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png', {
 			maxZoom: 16,
 			minZoom: 10,
 		}).addTo(this.map);

    this.layerGroup = L.layerGroup().addTo(this.map);
  }

  public toggleControl (item) {
    this.navCtrlr.map(el => this.navCtrlr[el.id].active = false);
    this.navCtrlr[item.id].active = true;

    // if (item.id == 1) {
      // this.drawBars(this.fullData, "");
    // }
  }

  public toggleView(event: any): void {
    this.isOpen = this.isOpen ? false : true;
  }

  public async ngOnChanges(changes: SimpleChanges) {
    if (changes.data.currentValue.payload.length) {
      let mapAct = changes.data.currentValue.map ? true : false;
      // TODO build dashboard
      if (mapAct) {
        this.buildMap(changes.data.currentValue, this.filter);
      }

      this.loading = false;
    }
  }

  private async buildMap (data: any, filter: any) {
    const controller = this;
    let i = 0; // group
    let k = 0; // ciclo
    //
    let dimension = data.dimensions[i];
    let filtered = data.payload.filter(el => el.item == data.metrics[i]);
    let grouped = filtered[0].group;
    //
    let iconMarker = L.icon({ iconUrl: 'marker-icon.png' });
    let MarkerOptions = {
      radius: 8,
      fillColor: "#ff7800",
      color: "#000",
      weight: 1,
      opacity: 1,
      fillOpacity: 0.8,
      border: 0,
      icon: iconMarker,
      outline: 0
    };

    let polyStyle = {
      default: {
        "color": "#1D4439",
        "fillColor": "#8DB85D",
        "weight": 2
      },
      selected: {
        "color": "#fff",
        "fillColor": "#0097A7",
        "weight": 2
      },
      hovered: {
        "color": "#8DB85D",
        "fillColor": "#1D4439",
        "weight": 2,
        "fillOpacity": 1
      }
    }

    // Cleanup before filling in map
    this.layerGroup.clearLayers();
    //
    // Build contol panel
    // Metric dropdown
    grouped.map((opts) => {
      controller.metricKeys.push(opts.metric);
      // let opt = this.renderer.createElement("option");
      // opt.value = opts.metric;
      // opt.innerHTML = opts.metric;

      // select.appendChild(opt);
    });


    // console.log("DATA => ", data);


    grouped[filter].data.map(async (arr) => {

      // TODO eval if marker o geo_shape

      let LatLong = Object.prototype.toString.call(arr[dimension]) == "[object String]" ? arr[dimension].split(",") : arr[dimension];
      //
      if (LatLong || LatLong.length > 1) {
      L.marker(LatLong, MarkerOptions)
        .bindPopup(`
          <b style="font-size: 16px;">${arr.nombre}</b><br><br>
          <b style="font-size: 14px;">${arr.id_ente} ${arr.ente}</b><br><br>
          <span><b>Servicios disponibles:</b><br> ${arr.servicios}</span><br><br>
          <span><b>Sede:</b> ${arr.sede}</span><br>
          <span><b>Dirección:</b> ${arr.calle_1} ${arr.colonia} ${arr.alcaldia}</span><br>
          <span><b>Teléfonos:</b> ${arr.telefono_1}</span><br>
          <span><b>Correo electrónico:</b> ${arr.correo_electronico}</span><br>
          <span><b>Horarios de atención:</b> ${arr.horario_de_atencion_horas}</span><br>
        `)
        .addTo(this.layerGroup);
      }
        // await mujeres.map(item => countMujer += item.numero );
        // await hombres.map(item => countHombre += item.numero );
        // let prct = (countMujer * 100 / this.countMujer) / 10;

    /*  L.geoJSON(arr.georreferencia, MarkerOptions), {
        style: {
          "color": "#1D4439",
          "fillColor": "#8DB85D",
          "weight": 2,
          "fillOpacity": prct
        },
      }).on('click', function (e) {

      }).on('mouseout', function (e) {
        e.layer.unbindTooltip();
      }).on('mouseover', function (e) {
        e.layer.bindTooltip(`
          <div style="background: white; color: black; padding: 8px; border-radius: 8px; ">
            <h3>${arr[0].nombre}</h3>
            <p>Total de empleados</p>
            <span>Total Mujeres: ${countMujer}</span><br>
            <span>Total Hombres: ${countHombre}</span>
          </div>
        `, { closeButton: true });

      }).addTo(this.layerGroupShapes);*/
    });
  }

  public async updateMetric (event: any, mt: any) {
    console.log("data ==> ", mt)
    console.log("item => ", mt.group.filter(el => el.metric == event.target.value));
    this.buildMap (mt, event.target.value);
  }

}
